angular.module("ainapp")
    .controller("attendanceReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Attendance Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

                $scope.filter = {
                    VoucherNo: "",
                    EmployeeIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                    IsOverTime: false,
                    IsUnderTime: false,
                    IsEarlyCheckout: false,
                    IsLateEntry: false,
                    IsStartNotPunched: false,
                    IsEndNotPunched: false,
                }

                $scope.load = false;
                $scope.isFilter = false;


                $scope.Columns = [{
                        field: "EmployeeAttendance.VoucherNo",
                        title: "Doc No #",
                        width: "120px",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        width: "100px",
                                            },
                    {
                        field: "WorkType.Name",
                        title: "Work Type",
                        width: "100px",
                                            },
                    {
                        field: "StartTime",
                        title: "Start Time",
                        width: "100px",
                        template: "<p>{{dataItem.StartTime | date:'dd/MM/yyyy @ h:mma'}}</p>"
                                            },
                    {
                        field: "EndTime",
                        title: "End Time",
                        width: "100px",
                        template: "<p>{{dataItem.EndTime | date:'dd/MM/yyyy @ h:mma'}}</p>"
                                            },
                    {
                        field: "TotalHours",
                        title: "Total Hours",
                        width: "100px",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                                            },
                    {
                        field: "NormalWorkingHours",
                        title: "Normal Working Hours",
                        width: "100px",
                                            },
                    {
                        field: "BreakHours",
                        title: "Break Hours",
                        width: "100px",
                                            },
                    {
                        field: "OverTimeHours",
                        title: "Over Time Hours",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        width: "100px",
                                            },
                    {
                        field: "IsStartNotPunched",
                        title: "Start Not Punched",
                        template: "<p ng-if='dataItem.IsStartNotPunched'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "IsEndNotPunched",
                        title: "End Not Punched",
                        template: "<p ng-if='dataItem.IsEndNotPunched'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "IsOverTime",
                        title: "Over Time",
                        template: "<p ng-if='dataItem.IsOverTime'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "IsUnderTime",
                        title: "Under Time",
                        template: "<p ng-if='dataItem.IsUnderTime'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "IsLateEntry",
                        title: "Late Entry",
                        template: "<p ng-if='dataItem.IsLateEntry'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "IsEarlyCheckout",
                        title: "Early Checkout",
                        template: "<p ng-if='dataItem.IsEarlyCheckout'>YES</p>",
                        width: "100px",
                                            },
                    {
                        field: "Status",
                        title: "Status",
                        width: "100px"
                                            }]

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Employee Attendance").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            //  template: "<a ng-repeat='cc in dataItem.SalesInvoiceCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                            width: '100px',
                            //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                        }
                        $scope.Columns.push(clm);
                    })


                    $scope.loadKendo1();
                });

            }
            $scope.Init();



            $scope.employeeSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.EmployeesInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    //toastr.error("NetworkError");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectEmployeeOptions = {
                placeholder: "Select Employees...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.employeeSelectDataSource
            };



            $scope.loadKendo1 = function () {
                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();
                            o.data.AccountIds = $scope.filter.AccountIds;

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.EmployeeIds = $scope.filter.EmployeeIds;

                            o.data.IsOverTime = $scope.filter.IsOverTime;
                            o.data.IsUnderTime = $scope.filter.IsUnderTime;
                            o.data.IsEarlyCheckout = $scope.filter.IsEarlyCheckout;
                            o.data.IsLateEntry = $scope.filter.IsLateEntry;
                            o.data.IsStartNotPunched = $scope.filter.IsStartNotPunched;
                            o.data.IsEndNotPunched = $scope.filter.IsEndNotPunched;


                            MainService.EmployeeAttendanceDetailReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })

                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (ee) {

                                angular.forEach(ee.items, function (e) {

                                    angular.forEach(arr, function (ar) {

                                        angular.forEach(e.EmployeeAttendanceCosts, function (a) {

                                            var afield = a.CostCenter.ParentName.replace(/ /g, '');
                                            afield = afield.replace('&', '');
                                            afield = "CC" + afield;

                                            if (afield == ar) {
                                                e[ar] = a.CostCenter.Name;
                                            }
                                        })


                                    })

                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "EmployeeAttendance.VoucherNo": {
                                    type: "string",
                                    editable: false,
                                },
                                "Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "StartTime": {
                                    type: "datetime-local",
                                    editable: false,
                                },
                                "EndTime": {
                                    type: "datetime-local",
                                    editable: false,
                                },
                                "TotalHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "NormalWorkingHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "BreakHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "OverTimeHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "IsStartNotPunched": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "IsEndNotPunched": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "IsOverTime": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "IsUnderTime": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "IsLateEntry": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "IsEarlyCheckout": {
                                    type: "boolean",
                                    editable: false,
                                },
                                "Status": {
                                    type: "string",
                                    editable: false,
                                },

                                "Employee.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                "WorkType.Name": {
                                    type: "string",
                                    editable: false,
                                },


                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                    group: [{
                        field: "Employee.Name",
                        aggregates: [{
                                field: "TotalHours",
                                aggregate: "sum"
                    },
                            {
                                field: "OverTimeHours",
                                aggregate: "sum"
                        }, ]
                    }],

                });

                $scope.KendoGridOptions = {


                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },

                    columns: $scope.Columns,
                };

            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();



                MainService.PrintCPVMasterReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
